import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const OFFER_DURATION = 5 * 60 * 1000; // 5 minutes in ms
export const useCountdown = () => {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 5,
    seconds: 0
  });
  useEffect(() => {
    let interval: ReturnType<typeof setInterval>;
    const getTarget = () => {
      let target = parseInt(localStorage.getItem('iphone_ads_countdown') || '0');
      const now = new Date().getTime();
      // Evergreen: if no target or it already expired, start a fresh 5min window
      if (!target || target <= now) {
        target = now + OFFER_DURATION;
        localStorage.setItem('iphone_ads_countdown', target.toString());
      }
      return target;
    };
    const tick = () => {
      const now = new Date().getTime();
      let distance = getTarget() - now;
      // Safety: never show zero, auto-reset to a fresh 5min window
      if (distance <= 0) {
        const target = now + OFFER_DURATION;
        localStorage.setItem('iphone_ads_countdown', target.toString());
        distance = OFFER_DURATION;
      }
      setTimeLeft({
        minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
        seconds: Math.floor(distance % (1000 * 60) / 1000)
      });
    };
    const initCountdown = () => {
      tick();
      interval = setInterval(tick, 1000);
    };
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(initCountdown);
    } else {
      setTimeout(initCountdown, 200);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, []);
  return timeLeft;
};
export const Countdown = () => {
  const timeLeft = useCountdown();
  const TimeUnit = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center justify-center bg-zinc-950/70 border border-white/[0.08] rounded-2xl py-3 px-2 w-24 md:w-28 shadow-lg relative overflow-hidden" data-id="element-261">
      <div className="absolute inset-0 bg-gradient-to-b from-blue-500/10 to-transparent" data-id="element-262"></div>
      <span className="text-4xl md:text-5xl font-extrabold text-white tracking-tight relative z-10 tabular-nums" data-id="element-263">
        {value.toString().padStart(2, '0')}
      </span>
      <span className="text-[10px] md:text-xs text-zinc-400 uppercase tracking-wider mt-1.5 relative z-10 font-semibold" data-id="element-264">
        {label}
      </span>
    </div>;
  return <div className="relative rounded-2xl p-5 md:p-6 bg-gradient-to-b from-zinc-900/80 to-zinc-950/90 border border-emerald-500/40 shadow-[0_0_30px_rgba(16,185,129,0.15)] overflow-hidden" data-id="element-265">
      <div className="absolute -top-1/2 left-1/2 -translate-x-1/2 w-2/3 h-full bg-blue-600/10 blur-3xl pointer-events-none" data-id="element-266"></div>
      <div className="relative z-10 flex flex-wrap items-center justify-center gap-2 mb-4" data-id="element-267">
        <span className="inline-flex items-center space-x-1.5 bg-emerald-500/10 border border-emerald-500/30 rounded-full px-3 py-1" data-id="element-268">
          <span className="flex h-2 w-2 rounded-full bg-emerald-500 animate-pulse" data-id="element-269"></span>
          <span className="text-xs font-bold text-emerald-400 uppercase tracking-wider" data-id="element-270">
            Oferta activa
          </span>
        </span>
        <span className="inline-flex items-center bg-blue-500/10 border border-blue-500/30 rounded-full px-3 py-1" data-id="element-271">
          <span className="text-xs font-bold text-blue-400 uppercase tracking-wider" data-id="element-272">
            Más de 50% OFF
          </span>
        </span>
      </div>
      <p className="relative z-10 text-center text-sm font-medium text-zinc-300 mb-4" data-id="element-273">
        Esta oferta termina en:
      </p>
      <div className="relative z-10 flex items-center justify-center space-x-3" data-id="element-274">
        <TimeUnit value={timeLeft.minutes} label="Minutos" data-id="element-275" />
        <span className="text-3xl md:text-4xl font-bold text-zinc-600" data-id="element-276">:</span>
        <TimeUnit value={timeLeft.seconds} label="Segundos" data-id="element-277" />
      </div>

      {/* Strong consequence message */}
      <p className="relative z-10 text-center text-sm md:text-base font-semibold text-amber-300 mt-5 leading-snug px-2" data-id="element-278">
        Cuando este contador llegue a 00:00, el precio vuelve a $40.000.
      </p>

      {/* HOY vs DESPUÉS comparison */}
      <div className="relative z-10 grid grid-cols-2 gap-3 mt-5" data-id="element-279">
        <div className="rounded-xl bg-emerald-500/10 border border-emerald-500/30 p-3 text-center" data-id="element-280">
          <p className="text-[10px] md:text-xs font-bold text-emerald-400 uppercase tracking-wider mb-1" data-id="element-281">
            Hoy
          </p>
          <p className="text-2xl md:text-3xl font-extrabold text-white tabular-nums" data-id="element-282">
            $19.000
          </p>
        </div>
        <div className="rounded-xl bg-zinc-800/40 border border-white/[0.08] p-3 text-center" data-id="element-283">
          <p className="text-[10px] md:text-xs font-bold text-zinc-400 uppercase tracking-wider mb-1" data-id="element-284">
            Después del contador
          </p>
          <p className="text-2xl md:text-3xl font-extrabold text-zinc-500 line-through tabular-nums" data-id="element-285">
            $40.000
          </p>
        </div>
      </div>

      {/* Savings reinforcement */}
      <p className="relative z-10 text-center text-sm font-semibold text-emerald-400 mt-4" data-id="element-286">
        Entrás con precio especial y ahorrás $21.000.
      </p>
    </div>;
};
export const InlineCTA = ({
  text
}: {
  text: string;
}) => {
  const CHECKOUT = 'https://sistema-iphone-ads.myshopify.com/cart/add?id=46176935641285&quantity=1&return_to=/cart';
  return <div className="max-w-3xl mx-auto px-6 pb-4 text-center" data-id="element-287">
      <Button href={CHECKOUT} className="w-full md:w-auto py-5 text-xl px-12" data-id="element-288">
        {text}
      </Button>
    </div>;
};
export const Button = ({
  children,
  variant = 'primary',
  className = '',
  onClick,
  href
}: {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  className?: string;
  onClick?: (e?: any) => void;
  href?: string;
}) => {
  const baseStyle = 'inline-flex items-center justify-center font-bold rounded-xl transition-all duration-200 text-center';
  const variants = {
    primary: 'bg-emerald-500 hover:bg-emerald-400 text-zinc-950 shadow-[0_0_20px_rgba(16,185,129,0.3)] hover:shadow-[0_0_30px_rgba(16,185,129,0.5)] scale-100 hover:scale-[1.02]',
    secondary: 'bg-blue-600 hover:bg-blue-500 text-white shadow-lg',
    outline: 'border-2 border-zinc-700 hover:border-zinc-500 text-zinc-300 hover:text-white'
  };
  const handleTrackAndClick = (e: React.MouseEvent) => {
    if (href) {
      e.preventDefault();
    }
    // Fire Meta Pixel Event
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart', {
        content_name: 'Sistema iPhone Ads',
        content_ids: ['46176935641285'],
        content_type: 'product',
        value: 19000,
        currency: 'ARS'
      });
    }
    if (onClick) onClick(e);
    if (href) {
      // Delay de 300ms para asegurar que Meta registre el evento antes de redirigir
      setTimeout(() => {
        window.location.href = href;
      }, 300);
    }
  };
  if (href) {
    return <a href={href} onClick={handleTrackAndClick} className={`${baseStyle} ${variants[variant]} px-8 py-4 text-lg md:text-xl w-full md:w-auto ${className}`} data-id="element-289">
        {children}
      </a>;
  }
  return <button className={`${baseStyle} ${variants[variant]} px-8 py-4 text-lg md:text-xl w-full md:w-auto ${className}`} onClick={handleTrackAndClick} data-id="element-290">
      {children}
    </button>;
};
export const Section = ({
  children,
  className = '',
  id
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) => {
  return <motion.section id={id} initial={{
    opacity: 0,
    y: 15
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.4,
    ease: 'easeOut'
  }} className={`py-12 md:py-24 px-6 md:px-12 max-w-6xl mx-auto ${className}`} data-id="element-291">
      {children}
    </motion.section>;
};
export const AccordionItem = ({
  question,
  answer
}: {
  question: string;
  answer: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-zinc-800 last:border-0" data-id="element-292">
      <button className="w-full py-6 flex items-center justify-between text-left focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-293">
        <span className="text-lg font-semibold text-zinc-100 pr-4" data-id="element-294">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-zinc-400 transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-295" />
      </button>
      <motion.div initial={false} animate={{
      height: isOpen ? 'auto' : 0,
      opacity: isOpen ? 1 : 0
    }} className="overflow-hidden" data-id="element-296">
        <p className="pb-6 text-zinc-400 leading-relaxed" data-id="element-297">{answer}</p>
      </motion.div>
    </div>;
};
export const MarqueeBar = () => {
  const timeLeft = useCountdown();
  const messages = ['Curso grabado', 'Acceso inmediato', <span key="price1" className="text-emerald-400 font-bold" data-id="element-298">
      Precio especial $19.000
    </span>, <span key="price2" className="text-zinc-500 line-through" data-id="element-299">
      Precio regular $40.000
    </span>, <span key="off" className="text-blue-400 font-bold" data-id="element-300">
      Más de 50% OFF
    </span>, 'Empezá sin stock propio', 'Vendé por pedido', 'Negocio + Marketing', 'Instagram, WhatsApp y Meta Ads', 'Aprendé a conseguir clientes', 'Evitá comprar mal', 'Acceso 100% digital', <span key="urgency1" className="text-amber-400 font-bold" data-id="element-301">
      Cuando termina el contador, vuelve a $40.000
    </span>, 'Entrás hoy por $19.000', <span key="urgency2" className="text-emerald-400 font-bold" data-id="element-302">
      Ahorrás $21.000
    </span>, 'Precio especial activo'];
  // Duplicamos para el loop infinito
  const duplicatedMessages = [...messages, ...messages];
  return <div className="w-full bg-gradient-to-r from-zinc-950 via-zinc-900 to-zinc-950 border-b border-blue-500/20 py-2 overflow-hidden relative flex items-center h-10 md:h-12" data-id="element-303">
      {/* Gradientes laterales para suavizar */}
      <div className="absolute top-0 left-0 w-8 md:w-16 h-full bg-gradient-to-r from-zinc-950 to-transparent z-10 pointer-events-none" data-id="element-304"></div>
      <div className="absolute top-0 right-0 w-8 md:w-16 h-full bg-gradient-to-l from-zinc-950 to-transparent z-10 pointer-events-none" data-id="element-305"></div>

      <div className="flex w-max animate-marquee hover:[animation-play-state:paused] items-center" data-id="element-306">
        {duplicatedMessages.map((msg, i) => <Fragment key={i} data-id="element-307">
            <span className="mx-4 md:mx-6 text-xs md:text-sm font-medium text-zinc-300 whitespace-nowrap flex items-center" data-id="element-308">
              {msg}
            </span>
            {/* Separador */}
            <span className="w-1 h-1 rounded-full bg-blue-500/50 flex-shrink-0" data-id="element-309"></span>

            {/* Insertar el mini contador cada ciertos mensajes para que aparezca varias veces en el loop */}
            {i % 5 === 0 && <>
                <span className="mx-4 md:mx-6 inline-flex items-center space-x-1.5 bg-zinc-950/80 border border-emerald-500/40 rounded-full px-3 py-1 shadow-sm whitespace-nowrap" data-id="element-310">
                  <span className="flex h-1.5 w-1.5 rounded-full bg-emerald-500 animate-pulse" data-id="element-311"></span>
                  <span className="text-[11px] md:text-xs font-bold text-zinc-200" data-id="element-312">
                    Oferta termina en{' '}
                    <span className="text-emerald-400 tabular-nums" data-id="element-313">
                      {timeLeft.minutes.toString().padStart(2, '0')}:
                      {timeLeft.seconds.toString().padStart(2, '0')}
                    </span>
                  </span>
                </span>
                <span className="w-1 h-1 rounded-full bg-blue-500/50 flex-shrink-0" data-id="element-314"></span>
              </>}
          </Fragment>)}
      </div>
    </div>;
};